// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/icon/iconfont.css'
import '../static/icon/iconfont.js'
import '../static/fonts/font.css'
import '../static/css/common.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { baseServer } from '@/api/api'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$orgId = 'ccc914581528a97bd03f10bde5b5bdea'
Vue.prototype.$getUrl = (params) => {
  return new Promise((resolve) => {
    baseServer.getImg(params).then(res => {
      let { code, data } = res
      if (code === '0') {
        resolve(data)
      } else {
        resolve({})
      }
    }).catch(() => {
      resolve({})
    })
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js